import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import {useLocation,useNavigate} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMenu,FiX,FiPhone}=FiIcons;

const Header=()=> {
  const [isMenuOpen,setIsMenuOpen]=useState(false);
  const location=useLocation();
  const navigate=useNavigate();

  const scrollToSection=(sectionId)=> {
    // If we're not on the home page,navigate to home first
    if (location.pathname !=='/' && location.hash !=='') {
      navigate('/');
      // Wait for navigation to complete then scroll
      setTimeout(()=> {
        const element=document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({behavior: 'smooth'});
        }
      },100);
    } else {
      const element=document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    }
    setIsMenuOpen(false);
  };

  const handleRetellVsThoughtlyClick=()=> {
    navigate('/retell-vs-thoughtly');
    setIsMenuOpen(false);
  };

  const handleHomeClick=()=> {
    navigate('/');
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-gray-700 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <button
              onClick={handleHomeClick}
              className="hover:opacity-80 transition-opacity duration-300"
            >
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751983148910-CRCAD-logo-Mater-1-png.png"
                alt="CRCAD Logo"
                className="h-10 w-auto object-contain"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={handleHomeClick}
              className="text-gray-300 hover:text-blue-400 transition-colors font-medium"
            >
              Home
            </button>
            <button
              onClick={handleRetellVsThoughtlyClick}
              className="text-gray-300 hover:text-blue-400 transition-colors font-medium"
            >
              Retell vs. Thoughtly
            </button>
            <button
              onClick={()=> scrollToSection('pricing')}
              className="text-gray-300 hover:text-blue-400 transition-colors font-medium"
            >
              Pricing
            </button>
            <button
              onClick={()=> scrollToSection('features')}
              className="text-gray-300 hover:text-blue-400 transition-colors font-medium"
            >
              Features
            </button>
            <a
              href="tel:+13322324531"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
            >
              <SafeIcon icon={FiPhone} className="w-4 h-4" />
              Call Now
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={()=> setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-800 transition-colors"
            aria-label="Toggle menu"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6 text-gray-300" />
          </button>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.nav
              initial={{opacity: 0,height: 0}}
              animate={{opacity: 1,height: 'auto'}}
              exit={{opacity: 0,height: 0}}
              className="md:hidden border-t border-gray-700 py-4"
            >
              <div className="flex flex-col space-y-4">
                <button
                  onClick={handleHomeClick}
                  className="text-gray-300 hover:text-blue-400 transition-colors font-medium text-left px-2 py-1"
                >
                  Home
                </button>
                <button
                  onClick={handleRetellVsThoughtlyClick}
                  className="text-gray-300 hover:text-blue-400 transition-colors font-medium text-left px-2 py-1"
                >
                  Retell vs. Thoughtly
                </button>
                <button
                  onClick={()=> scrollToSection('pricing')}
                  className="text-gray-300 hover:text-blue-400 transition-colors font-medium text-left px-2 py-1"
                >
                  Pricing
                </button>
                <button
                  onClick={()=> scrollToSection('features')}
                  className="text-gray-300 hover:text-blue-400 transition-colors font-medium text-left px-2 py-1"
                >
                  Features
                </button>
                <a
                  href="tel:+13322324531"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2 w-fit"
                  onClick={()=> setIsMenuOpen(false)}
                >
                  <SafeIcon icon={FiPhone} className="w-4 h-4" />
                  Call Now
                </a>
              </div>
            </motion.nav>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default Header;